import { useEffect, useRef, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

import '../view.css';
import './projects.css';

import processoricon from './projecticons/processoricon.ico';
import benchpowersupplyicon from './projecticons/benchpowersupplyicon.ico';
import cncroutericon from './projecticons/cncroutericon.ico';
import droneicon from './projecticons/droneicon.ico';
import gokarticon from './projecticons/gokarticon.ico';
import smartroomicon from './projecticons/smartroomicon.ico';

import uparrow from './projecticons/uparrow.png';
import ParticlesComponent from "../../components/particles/particlescomponent";
import { GlowingText2em } from "../../components/glowingtextcomponet/glowingtext2em.js";

const PROJECT_ITEMS = [
  { to: '/projects/bench-power-supply', label: 'Bench Power Supply', icon: benchpowersupplyicon },
  { to: '/projects/drone', label: 'Drone', icon: droneicon },
  { to: '/projects/go-kart', label: 'Go Kart', icon: gokarticon },
  { to: '/projects/processor', label: 'Processor', icon: processoricon },
  { to: '/projects/smart-room', label: 'Smart Room', icon: smartroomicon },
  { to: '/projects/cnc-router', label: 'CNC Router', icon: cncroutericon },
];

const Projects = () => {
  const location = useLocation();
  const viewRef = useRef(null);
  const navRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const path = location.pathname.replace(/(.)\/+$/, '$1');
  const selectedProject = path !== '/projects';

  // Collapse the sidebar whenever we're back on the projects landing page.
  useEffect(() => {
    if (!selectedProject) setMenuOpen(false);
  }, [selectedProject]);

  // Keep the absolute sidebar as tall as the content (can't be expressed in CSS).
  useEffect(() => {
    const view = viewRef.current;
    const nav = navRef.current;
    if (!view || !nav) return undefined;
    const sync = () => { nav.style.height = `${view.offsetHeight + 50}px`; };
    sync();
    const observer = new ResizeObserver(sync);
    observer.observe(view);
    return () => observer.disconnect();
  }, []);

  // Reveal the scroll-to-top button after scrolling down.
  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 100);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div
      className='view'
      id='projectview'
      ref={viewRef}
      style={{ gridTemplateColumns: menuOpen ? '270px 1fr' : '120px 1fr' }}
    >
      <div className={menuOpen ? 'navigationprojects active' : 'navigationprojects'} ref={navRef}>
        <div className='menuToggle' onClick={() => setMenuOpen((open) => !open)}></div>
        <ul>
          {PROJECT_ITEMS.map(({ to, label, icon }) => (
            <li key={to} className={path === to ? 'projectslist active' : 'projectslist'}>
              <Link to={to}>
                <span className='icon'><img src={icon} alt={label} /></span>
                <span className='projecttitle'>{label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="projectcontent">
        {selectedProject ? (
          <Outlet />
        ) : (
          <div className="projectmainscreen">
            <div className="myprojectstitle">
              <GlowingText2em content='My Projects' />
              <p className='projecttext'>
                feel free to explore them in the menu on the left
              </p>
            </div>
            <ParticlesComponent />
          </div>
        )}

        {selectedProject && (
          <div
            className="fixed-button"
            onClick={scrollToTop}
            style={{ display: showScrollTop ? 'flex' : 'none' }}
          >
            <img src={uparrow} alt='Scroll Back' />
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;
